import { gql } from "@apollo/client";

export const PARTNER_SYNCHRONIZATION_QUEUE_QUERY = gql`
  query partnerSynchronizationQueue($pager: PagerInput!, $filters: PartnerSynchronizationFilters!) {
    partnerSynchronizationQueue(pager: $pager, filters: $filters) {
      total
      values {
        id
        partnerId
        uniqueId
        partnerCode
        partnerName
        requestMoment
        errorMessage
        status
        completed
      }
    }
  }
`;

export const PARTNER_SYNCHRONIZATION_STATUS_LIST_QUERY = gql`
  query partnerSynchronizationStatusList {
    partnerSynchronizationStatusList {
      name
    }
  }
`;
